"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import renderIcon from "../../icons/render-icon.js";
import makeStyles from "../../theming/make-styles.js";
import makePadding from "../utils/make-padding.js";
import { TableContext, TableSectionContext } from "./table.js";
const paddings = {
    small: { x: "md", y: "sm" },
    medium: { x: "md", y: 12 },
    large: { x: "md", y: "md" },
};
const useStyles = makeStyles()((theme, { align, borders, color, selectable, size, sticky }, classes) => {
    const palette = theme.palette(color).table;
    const padding = makePadding(paddings, theme);
    const cellAlign = {
        "left": { textAlign: "left" },
        "center": { textAlign: "center" },
        "right": { textAlign: "right" },
        "top-left": { textAlign: "left", verticalAlign: "top" },
        "top-center": { textAlign: "center", verticalAlign: "top" },
        "top-right": { textAlign: "right", verticalAlign: "top" },
        "bottom-left": { textAlign: "left", verticalAlign: "bottom" },
        "bottom-center": { textAlign: "center", verticalAlign: "bottom" },
        "bottom-right": { textAlign: "right", verticalAlign: "bottom" },
    };
    return {
        cell: Object.assign(Object.assign({ "position": sticky ? "sticky" : undefined, "left": sticky ? (selectable ? 40 : 0) : undefined, "padding": padding(size, "0"), "fontSize": theme.typography.small.fontSize, "backgroundClip": "padding-box", "backgroundColor": palette.cell.backgroundColor }, cellAlign[align]), { "&:first-of-type": {
                borderLeft: borders.vertical === "all" ? `${theme.size(1)} solid ${palette.row.borderColor}` : undefined,
            }, "&:last-of-type": {
                right: sticky ? 0 : undefined,
                left: sticky ? "auto" : undefined,
                borderRight: borders.vertical === "all" ? `${theme.size(1)} solid ${palette.row.borderColor}` : undefined,
            }, [`& + .${classes.cell}`]: {
                borderLeft: borders.vertical && ["all", "between"].includes(borders.vertical) ? `${theme.size(1)} solid ${palette.row.borderColor}` : undefined,
            }, "& svg.unsorted-icon": {
                color: palette.cell.svg.color,
            } }),
        icon: {
            marginLeft: theme.spacing(12),
        },
        wrapper: {
            display: "inline-grid",
            gridTemplateColumns: "minmax(min-content, max-content) auto",
            alignItems: "center",
        },
    };
});
export const TableCell = React.forwardRef(function TableCell(_a, ref) {
    var { align = "left", children, className, color = "primary", icon, sticky = false } = _a, props = __rest(_a, ["align", "children", "className", "color", "icon", "sticky"]);
    const { borders, selectable, size } = useContext(TableContext);
    const { classes, cx } = useStyles({ align, borders, color, selectable, size, sticky });
    const { parent } = useContext(TableSectionContext);
    const Component = parent === "TableHead" ? "th" : "td";
    return (_jsx(Component, Object.assign({ ref: ref, className: cx(classes.cell, className) }, props, { children: icon ? (_jsxs("div", { className: classes.wrapper, children: [children, renderIcon(icon, classes.icon)] })) : (children) })));
});
export default React.memo(TableCell);
//# sourceMappingURL=table-cell.js.map